import { RootState } from '../store';

export const selectScroll = (state: RootState) => state.scroll;
